import React from "react";
import ReactDOM from "react-dom";
import MainRouter from "./routers/MainRouter";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import "./styles/main_global.css";
import { store } from "./main-store/store";

ReactDOM.render(
  <Provider store={store}>
    <MainRouter />
  </Provider>,
  document.getElementById("root")
);
serviceWorker.unregister();
